import styled from "@emotion/styled";

export const DivContainerTable = styled.div`
  overflow-x: auto;
  width: 100%;
`;